import React from 'react';
import BasicCard from '../components/BasicCard';
import HubSpotContactForm from '../components/HubSpotContactForm';
import styles from '../styles/Contact.module.css';

export default function Contact() {
    return (
        <main className={styles.pageContainer}>
            {/*
              pageLayout: two-track grid (80px index rail | 1fr content).
              The rail's border-right is the same --rule as the navbar logo cell
              and footer index cell — so the vertical line is continuous on every page.
            */}
            <div className={styles.pageLayout}>

                {/* Index rail — rotated label + continuous vertical rule */}
                <div className={styles.indexRail} aria-hidden="true">
                    <span className={styles.indexRailLabel}> Website Design Video Production Jacksonville FL </span>
                </div>

                {/* Right track: all page content */}
                <div className={styles.mainContent}>
                    <div className={styles.contactGrid}>
                        <BasicCard
                            className={styles.contactCard}
                            header={
                                <div className={styles.contactHeader}>
                                    {/* Left 6 cols: kicker + display title */}
                                    <div className={styles.headingGroup}>
                                        <span className={styles.headingKicker}>contact</span>
                                        <h1 className={styles.headingMain}>
                                            Send us a message.

                                        </h1>
                                    </div>

                                    {/* Right 6 cols: descriptor */}
                                    <div className={styles.headingMeta}>
                                        <span className={styles.headingRole}>
                                            Use this form for general inquiries, collaborations, and quick questions. If you&apos;re ready
                                            to start a new project, you can skip ahead to the{' '}
                                            <a href="/new-client" className={styles.inlineLink}>
                                                new client questionnaire
                                            </a>{' '}
                                            so we have the right details from the beginning.
                                        </span>
                                    </div>
                                </div>
                            }
                            headerClassName={styles.contactCardHeader}
                            bodyClassName={styles.contactCardBody}
                        >
                            <div className={styles.contactCopyGrid}>

                                <aside className={styles.contactInfoBlock} aria-label="Contact information">


                                    <div className={styles.contactInfoList}>
                                        <a
                                            href="mailto:admin@meshaestudios.com"
                                            className={styles.contactInfoItem}
                                        >
                                            <span className={styles.contactIcon} aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="5" width="18" height="14" rx="1" />
                                                    <path d="m4 7 8 6 8-6" />
                                                </svg>
                                            </span>

                                            <span className={styles.contactInfoText}>
                                                <span className={styles.contactInfoLabel}>Email address</span>
                                                <span className={styles.contactInfoValue}>
                                                    admin@meshaestudios.com
                                                </span>
                                            </span>
                                        </a>

                                        <a
                                            href="https://www.instagram.com/meshae_studios/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.contactInfoItem}
                                            aria-label="Visit Meshae Studios on Instagram"
                                        >
                                            <span className={styles.contactIcon} aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="3" width="18" height="18" rx="5" />
                                                    <circle cx="12" cy="12" r="4" />
                                                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                                                </svg>
                                            </span>

                                            <span className={styles.contactInfoText}>
                                                <span className={styles.contactInfoLabel}>Instagram</span>
                                                <span className={styles.contactInfoValue}>@meshae_studios</span>
                                            </span>
                                        </a>

                                        <a
                                            href="https://www.youtube.com/@meshaestudios"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.contactInfoItem}
                                            aria-label="Visit Meshae Studios on YouTube"
                                        >
                                            <span className={styles.contactIcon} aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="6" width="18" height="12" rx="3" />
                                                    <path d="m10 9 5 3-5 3V9Z" fill="currentColor" stroke="none" />
                                                </svg>
                                            </span>

                                            <span className={styles.contactInfoText}>
                                                <span className={styles.contactInfoLabel}>YouTube</span>
                                                <span className={styles.contactInfoValue}>Meshae Studios</span>
                                            </span>
                                        </a>

                                        <a
                                            href="https://www.facebook.com/p/Meshae-Studios-61584826494736/"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.contactInfoItem}
                                            aria-label="Visit Meshae Studios on Facebook"
                                        >
                                            <span className={styles.contactIcon} aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none">
                                                    <path d="M14 21v-8h3l.5-3H14V8.2c0-.9.3-1.5 1.6-1.5H18V4.1c-.4-.1-1.3-.1-2.3-.1-2.3 0-3.8 1.4-3.8 4V10H9v3h2.9v8H14Z" />
                                                </svg>
                                            </span>

                                            <span className={styles.contactInfoText}>
                                                <span className={styles.contactInfoLabel}>Facebook</span>
                                                <span className={styles.contactInfoValue}>Meshae Studios</span>
                                            </span>
                                        </a>

                                        <a
                                            href="https://vimeo.com/meshaestudios"
                                            target="_blank"
                                            rel="noreferrer"
                                            className={styles.contactInfoItem}
                                            aria-label="Visit Meshae Studios on Vimeo"
                                        >
                                            <span className={styles.contactIcon} aria-hidden="true">
                                                <svg viewBox="0 0 24 24" fill="none">
                                                    <path d="M3 7.7c2.1-2.2 4.3-3.3 5.8-3.3 1.7 0 2.3 1 2.8 3.1.6 2.8 1.1 5.5 1.6 5.5.4 0 1.3-1.4 2.6-4.1.6-1.2.5-1.8-.4-1.8-.4 0-.8.1-1.2.3.8-2.6 2.3-3.8 4.4-3.7 1.6 0 2.4.9 2.2 2.8-.1 1.3-1.2 3.7-3.4 7.1-2.2 3.5-4.1 5.2-5.7 5.2-1.9 0-3.6-1.8-4.9-5.4C5.6 8.8 5.1 7.8 4.4 7.8c-.3 0-.8.3-1.4.8V7.7Z" />
                                                </svg>
                                            </span>

                                            <span className={styles.contactInfoText}>
                                                <span className={styles.contactInfoLabel}>Vimeo</span>
                                                <span className={styles.contactInfoValue}>Meshae Studios</span>
                                            </span>
                                        </a>
                                    </div>
                                </aside>


                                {/* Right 6 cols: HubSpot form */}
                                <div className={styles.contactFormBlock}>
                                    <HubSpotContactForm />
                                </div>
                            </div>
                        </BasicCard>
                    </div>
                </div>{/* end .mainContent */}

            </div>{/* end .pageLayout */}
        </main>
    );
}